import * as z from "zod/v4";
export const OperatorSchema = z.enum(["CONTAINS"]);
//# sourceMappingURL=operator.js.map